<template lang="pug">
//- include login.pug
.login
  p.title {{ $t('login.cta') }}
  form.form(@submit.prevent='loginUser')
    ed-input(name='username' type='email' :field-label='$t("login.Email")' :placeholder='$t("login.emailHint")' v-model='loginDetails.username')
    ed-input(name='password' type='password' show-password :field-label='$t("login.Password")' :placeholder='$t("login.passwordHint")' v-model='loginDetails.password')
    button.btn.btn-primary.float-right.pull-right(type='submit' value='login' :endpoint='this.api.$.login') {{ $t('login.button') }}
    .alert.alert-danger(v-if='loginError.message' role='alert') {{ $t(loginError.message) }}
</template>

<script>
/* eslint no-multi-spaces: 0 */
import loginService from './loginService.js'

export default {
  alias: 'login',
  data() {
    return {
      loginDetails: {
        username: '',
        password: ''
      },
      loginError: {
        message: ''
      }
    }
  },

  methods: {
    /**
     * Authenticates user on PHP endpoint
     * then init user in app
     */
    loginUser() {
      loginService.login.call(this, this.loginDetails)
        .then(res  => { loginService.init.call(this, res) })
        .catch(err => { loginService.handle(err) })
    },

    /**
     * Check user authorization on landing in login
     * then redirect acordingly
     */
    loginAuth() {
      loginService.auth.call(this)
    }
  },

  created() {
    this.loginAuth()
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "login.scss";

.login .title {
  font-weight: $font-weight-extra-bold;
  margin-bottom: 1rem;
}
.login .navbar .navbar-brand.logo {
  img { display: inline; }
}

</style>



// WEBPACK FOOTER //
// index.vue?db34ae62